import { render, staticRenderFns } from "./ThanksModal.vue?vue&type=template&id=6e10c3db&scoped=true&"
import script from "./ThanksModal.vue?vue&type=script&lang=js&"
export * from "./ThanksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10c3db",
  null
  
)

export default component.exports